module.exports = __webpack_public_path__ + "static/media/wo.bc10c780.png";